import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import WSCBlazeStoriesComponent from './js/wsc-blaze-stories.component';

ComponentsFactory.getInstance().define('wsc-blaze-stories', WSCBlazeStoriesComponent);
